import request, { _POST } from "@/services/request";

export type ParticipantInfo = {
  mobile: string;
  name: string;
  channelId: string;
  type: number;
  channelName: string;
  channelHeadImg: string;
  headImg?: string;
  status: number;
  token?: string;
  types?: number[];
  isAdmin?: boolean;
};

export type PasswordLoginReq = {
  phoneNumber: string;
  password: string;
  type: number;
};

const passwordLogin = (params: Pick<PasswordLoginReq, "phoneNumber" | "password">) =>
  request<ParticipantInfo, PasswordLoginReq>(
    _POST,
    "/admin/auth/password-login"
  )({
    ...params,
    type: 3,
  });

const getParticipantInfo = () => request<ParticipantInfo, Record<string, never>>(_POST, "/admin/participant/info")({});

const authApis = {
  passwordLogin,
  getParticipantInfo,
};

export default authApis;
